// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import VueCookies from 'vue-cookies'
import VueMoment from 'vue-moment'
import moment from 'moment-timezone'
import VueDraggable from 'vue-draggable'

import AuthGuard from './AuthGuard'

import router from './router'
import store from './store'
import _ from 'lodash';   

// import "buefy/dist/buefy.css"
// import 'bulma/css/bulma.css'

import Dialog from 'buefy/dist/components/dialog'
import Loading from 'buefy/dist/components/loading'
import Notification from 'buefy/dist/components/notification'

Vue.config.productionTip = false

Vue.use(VueCookies);
Vue.use(VueMoment, {
    moment
});
Vue.use(VueDraggable);

Vue.use(Notification);
Vue.use(Dialog);
Vue.use(Loading)

Object.defineProperty(Vue.prototype, '$_', { value: _ });
Vue.prototype.$eventHub = new Vue();

/* eslint-disable no-new */
new Vue({
	el: '#main',
	router,
	store,
	components: { AuthGuard },
	template: '<AuthGuard />'
})



// WEBPACK FOOTER //
// ./src/main.js